export const isEmptyObject = (obj: Record<any, any> | null | undefined) => {
  if (!obj) {
    return true;
  }

  for (const key in obj) {
    return false;
  }

  return true;
};
